// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './index.css';
// import App from './App';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';
// import './styles/overrides.css';
// import './styles/ios-pwa-fixes.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://cra.link/PWA
// // serviceWorkerRegistration.register();

// serviceWorkerRegistration.register({
//   onSuccess: (registration) => {
//     console.log('PWA registered successfully. App can now work offline!');
//   },
//   onUpdate: (registration) => {
//     console.log('New version available! Please refresh to update.');
//     // Optional: Show a toast or notification to user about the update
//     // You can implement a custom update notification here
//   }
// });

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './styles/overrides.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * CRITICAL FIX FOR iOS PWA SUPPORT
 * 
 * Changed from unregister() to register() to enable PWA functionality
 * on all iOS devices. This enables:
 * - Offline support
 * - Add to Home Screen functionality
 * - Splash screens on iOS
 * - Push notifications (where supported)
 * - Faster load times through caching
 */
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('PWA registered successfully. App can now work offline!');
  },
  onUpdate: (registration) => {
    console.log('New version available! Please refresh to update.');
    // Optional: Show a toast or notification to user about the update
    // You can implement a custom update notification here
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();